import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Clickable,
  Icon,
  InputGroup,
  Menu,
  MenuItem,
  MenuStateProvider,
  useMenuButtonBehavior
} from '@maui/elements'

export const ClickableInputGroup = React.forwardRef(({ children, ...props }, ref) => {
  props = useMenuButtonBehavior({ ...props, ref })

  return (
    <Clickable
      {...props}
      userSelect="none"
      display="inline-flex"
      width="100%"
    >
      {children}
    </Clickable>
  )
})

ClickableInputGroup.displayName = 'ClickableInputGroup'

ClickableInputGroup.propTypes = {
  children: PropTypes.node,
}

export const DropDownSelect = ({ onClick, menuLabel, list, selectedItem, name, id }) => {
  const menuWidth = '250px'
  return (
    <>
      <Box display="flex" gap="12px">
        <Box>
          <MenuStateProvider>
            <Box
              display='inline-block'
              userSelect='none'
              fontWeight='700'
              width={menuWidth}
              color='colorActivePrimary'
              cursor='pointer'
            >
              <ClickableInputGroup>
                <InputGroup
                  width='100%'
                  size='medium'
                  inputProps={{
                    cursor: 'pointer',
                    value: selectedItem || '',
                    placeholder: 'select an option',
                    readOnly: true,
                    name,
                    id,
                  }}
                  slotRight={<Icon name='angle-down' />}
                />
              </ClickableInputGroup>
            </Box>
            <Menu aria-label={menuLabel} width={menuWidth} maxHeight="300px" overflowY={list.length > 10 && 'scroll'} overflowX="hidden">
              {list.map((listItem, index) =>
                <MenuItem key={index} onClick={() => onClick(listItem)} width={menuWidth} backgroundColor={selectedItem === listItem && 'colorFillEmphasis'}>
                  <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
                    { listItem } { selectedItem === listItem && <Icon name='check' color='colorActivePrimary' size="sm"/> }
                  </Box>
                </MenuItem>
              )}
            </Menu>
          </MenuStateProvider>
        </Box>
      </Box>
    </>
  )
}

DropDownSelect.propTypes = {
  onClick: PropTypes.func,
  menuLabel: PropTypes.string,
  list: PropTypes.array,
  selectedItem: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
}
